import { parseOwnedOrigins } from "./owned-origins"

/**
 * Runtime accessor: current origin + `VITE_OWNED_ORIGINS` (legacy + aliases).
 * This is the ONLY owned-origins file that touches `import.meta.env`, so it must
 * never be imported by a Jest test (invalid under CJS ts-jest). The pure logic
 * lives in owned-origins.ts; this read is exercised by the Playwright e2e.
 */
export function getOwnedOrigins(): string[] {
	const current = typeof window !== "undefined" ? window.location.origin : ""
	const csv = import.meta.env?.VITE_OWNED_ORIGINS ?? ""
	return parseOwnedOrigins(current, csv)
}
